__turbopack_context__.v({
  "actionCard": "ActionPlanDisplay-module__s5lFWW__actionCard",
  "actionCheckbox": "ActionPlanDisplay-module__s5lFWW__actionCheckbox",
  "actionCompleted": "ActionPlanDisplay-module__s5lFWW__actionCompleted",
  "actionDescription": "ActionPlanDisplay-module__s5lFWW__actionDescription",
  "actionHeader": "ActionPlanDisplay-module__s5lFWW__actionHeader",
  "actionIcon": "ActionPlanDisplay-module__s5lFWW__actionIcon",
  "actionMeta": "ActionPlanDisplay-module__s5lFWW__actionMeta",
  "actionPriority": "ActionPlanDisplay-module__s5lFWW__actionPriority",
  "actionTime": "ActionPlanDisplay-module__s5lFWW__actionTime",
  "actionTitle": "ActionPlanDisplay-module__s5lFWW__actionTitle",
  "actionType": "ActionPlanDisplay-module__s5lFWW__actionType",
  "actionsList": "ActionPlanDisplay-module__s5lFWW__actionsList",
  "activeMonthTab": "ActionPlanDisplay-module__s5lFWW__activeMonthTab",
  "blockersList": "ActionPlanDisplay-module__s5lFWW__blockersList",
  "checkbox": "ActionPlanDisplay-module__s5lFWW__checkbox",
  "checkboxLabel": "ActionPlanDisplay-module__s5lFWW__checkboxLabel",
  "checkpoints": "ActionPlanDisplay-module__s5lFWW__checkpoints",
  "checkpointsLabel": "ActionPlanDisplay-module__s5lFWW__checkpointsLabel",
  "completed": "ActionPlanDisplay-module__s5lFWW__completed",
  "container": "ActionPlanDisplay-module__s5lFWW__container",
  "criticalPathItem": "ActionPlanDisplay-module__s5lFWW__criticalPathItem",
  "criticalPathList": "ActionPlanDisplay-module__s5lFWW__criticalPathList",
  "criticalPathNumber": "ActionPlanDisplay-module__s5lFWW__criticalPathNumber",
  "criticalPathSection": "ActionPlanDisplay-module__s5lFWW__criticalPathSection",
  "customCheckbox": "ActionPlanDisplay-module__s5lFWW__customCheckbox",
  "dismissButton": "ActionPlanDisplay-module__s5lFWW__dismissButton",
  "expandIcon": "ActionPlanDisplay-module__s5lFWW__expandIcon",
  "expanded": "ActionPlanDisplay-module__s5lFWW__expanded",
  "exportNote": "ActionPlanDisplay-module__s5lFWW__exportNote",
  "exportSection": "ActionPlanDisplay-module__s5lFWW__exportSection",
  "free": "ActionPlanDisplay-module__s5lFWW__free",
  "freemium": "ActionPlanDisplay-module__s5lFWW__freemium",
  "header": "ActionPlanDisplay-module__s5lFWW__header",
  "headerContent": "ActionPlanDisplay-module__s5lFWW__headerContent",
  "headerIcon": "ActionPlanDisplay-module__s5lFWW__headerIcon",
  "insightCard": "ActionPlanDisplay-module__s5lFWW__insightCard",
  "insightsGrid": "ActionPlanDisplay-module__s5lFWW__insightsGrid",
  "metricCheck": "ActionPlanDisplay-module__s5lFWW__metricCheck",
  "metricItem": "ActionPlanDisplay-module__s5lFWW__metricItem",
  "metricsGrid": "ActionPlanDisplay-module__s5lFWW__metricsGrid",
  "monthContent": "ActionPlanDisplay-module__s5lFWW__monthContent",
  "monthGoal": "ActionPlanDisplay-module__s5lFWW__monthGoal",
  "monthHeader": "ActionPlanDisplay-module__s5lFWW__monthHeader",
  "monthNumber": "ActionPlanDisplay-module__s5lFWW__monthNumber",
  "monthProgress": "ActionPlanDisplay-module__s5lFWW__monthProgress",
  "monthProgressFill": "ActionPlanDisplay-module__s5lFWW__monthProgressFill",
  "monthTab": "ActionPlanDisplay-module__s5lFWW__monthTab",
  "monthTabs": "ActionPlanDisplay-module__s5lFWW__monthTabs",
  "monthTheme": "ActionPlanDisplay-module__s5lFWW__monthTheme",
  "overviewCard": "ActionPlanDisplay-module__s5lFWW__overviewCard",
  "overviewGrid": "ActionPlanDisplay-module__s5lFWW__overviewGrid",
  "overviewIcon": "ActionPlanDisplay-module__s5lFWW__overviewIcon",
  "overviewLabel": "ActionPlanDisplay-module__s5lFWW__overviewLabel",
  "overviewValue": "ActionPlanDisplay-module__s5lFWW__overviewValue",
  "paid": "ActionPlanDisplay-module__s5lFWW__paid",
  "printButton": "ActionPlanDisplay-module__s5lFWW__printButton",
  "priorityCritical": "ActionPlanDisplay-module__s5lFWW__priorityCritical",
  "priorityHigh": "ActionPlanDisplay-module__s5lFWW__priorityHigh",
  "priorityMedium": "ActionPlanDisplay-module__s5lFWW__priorityMedium",
  "probachievable": "ActionPlanDisplay-module__s5lFWW__probachievable",
  "probhigh": "ActionPlanDisplay-module__s5lFWW__probhigh",
  "probmedium": "ActionPlanDisplay-module__s5lFWW__probmedium",
  "progressBar": "ActionPlanDisplay-module__s5lFWW__progressBar",
  "progressFill": "ActionPlanDisplay-module__s5lFWW__progressFill",
  "progressHeader": "ActionPlanDisplay-module__s5lFWW__progressHeader",
  "progressPercent": "ActionPlanDisplay-module__s5lFWW__progressPercent",
  "progressSection": "ActionPlanDisplay-module__s5lFWW__progressSection",
  "progressStats": "ActionPlanDisplay-module__s5lFWW__progressStats",
  "quickWinItem": "ActionPlanDisplay-module__s5lFWW__quickWinItem",
  "quickWinTime": "ActionPlanDisplay-module__s5lFWW__quickWinTime",
  "quickWinsHeader": "ActionPlanDisplay-module__s5lFWW__quickWinsHeader",
  "quickWinsList": "ActionPlanDisplay-module__s5lFWW__quickWinsList",
  "quickWinsSection": "ActionPlanDisplay-module__s5lFWW__quickWinsSection",
  "resourceCost": "ActionPlanDisplay-module__s5lFWW__resourceCost",
  "resourceTag": "ActionPlanDisplay-module__s5lFWW__resourceTag",
  "resourceTags": "ActionPlanDisplay-module__s5lFWW__resourceTags",
  "resources": "ActionPlanDisplay-module__s5lFWW__resources",
  "resourcesLabel": "ActionPlanDisplay-module__s5lFWW__resourcesLabel",
  "successList": "ActionPlanDisplay-module__s5lFWW__successList",
  "weekActions": "ActionPlanDisplay-module__s5lFWW__weekActions",
  "weekBlock": "ActionPlanDisplay-module__s5lFWW__weekBlock",
  "weekFocus": "ActionPlanDisplay-module__s5lFWW__weekFocus",
  "weekHeader": "ActionPlanDisplay-module__s5lFWW__weekHeader",
  "weekInfo": "ActionPlanDisplay-module__s5lFWW__weekInfo",
  "weekMeta": "ActionPlanDisplay-module__s5lFWW__weekMeta",
  "weekMilestone": "ActionPlanDisplay-module__s5lFWW__weekMilestone",
  "weekNumber": "ActionPlanDisplay-module__s5lFWW__weekNumber",
  "weekTheme": "ActionPlanDisplay-module__s5lFWW__weekTheme",
  "weekTimeline": "ActionPlanDisplay-module__s5lFWW__weekTimeline",
});
